import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, Events, ActionSheetController } from 'ionic-angular';
import { FeedData } from '../../providers/feed-data';
import { UserData } from '../../providers/user-data';
import { Utils } from '../../providers/utils';
import { ModalPostSubmit } from '../../components/modal-post-submit';
import { ModalMediaSubmit } from '../../components/modal-media-submit';
import { ModalCommentSubmit } from '../../components/modal-comment-submit'; 
import { ModalShareSubmit } from '../../components/modal-share-submit'; 
import { EventCodes } from '../../core/codes';
import { Camera } from 'ionic-native';
import { AccountPage } from '../../modules/account/pages/account/account';
import { UserFeedPage } from '../feed/user-feed';
import { NewsDetailsPage } from '../news/news-details';
import { Helpers } from '../../providers/helpers';
import { AppSettings } from '../../config/app-settings';

import _ from 'lodash';

declare var window: any;
declare var cordova: any;
declare var navigator: any;

@Component({
    selector: 'page-feed',
    templateUrl: 'feed.html'

})
export class FeedPage {
    public postsData = [];
    public event: any;
    public items: any;
    public isShowingSuggestedKeywords: boolean = false;
    public currentUser: any;
    public modal: any;
    public isLoadingTimeLine: boolean = true;
    public loading: any;
    public hasNewPost: boolean = false;
    private newPost: any;
    private loadedOnce: boolean = false;
    private tasksToLoad: number = 0;

    constructor(
        private nav: NavController, 
        private params: NavParams,
        private helpers: Helpers,
        private userData: UserData,
        private feedData: FeedData,
        private events: Events,
        private settings: AppSettings,
        private modalController: ModalController,
        private actionsheetController: ActionSheetController
    ) {
        let self = this;
        this.updateLike(null, true);
        this.initializeItems();
        this.events.subscribe(EventCodes.POST_SUBMITTED, (_newPost)=>{
            if(_newPost && _newPost.length > 0){
                // console.log(_newPost[0]);
                self.newPost = _newPost.post;
                if(_newPost.media){
                    self.newPost.media = _newPost.media.value;
                    // console.log(self.newPost.media);
                }
                self.postsData.unshift(self.newPost);
            }
            setTimeout(()=>{
                self.closeModals();    
            },100);
            
        });

        this.events.subscribe(EventCodes.POST_SUBMITTED_ERROR, ()=>{
            setTimeout(()=>{
                self.closeModals();    
            },100);
        });

        this.events.subscribe(EventCodes.POST_LOADED, ()=>{
            if(!self.loadedOnce){
                
                self.feedData.listenForNewPosts().subscribe(_newPost =>{
                    // Only show if there is new post after 10s
                    setTimeout(()=>{
                        if(_newPost.key != self.newPost.key){
                            // console.log(_newPost);
                            self.hasNewPost = true;
                            console.log("Has new posts");
                        }
                    }, 10000);
                });  
                
            }  
            self.loadedOnce = true;
        });
    }

    ionViewDidEnter() {
        var self = this;
        // Load from cache fist
        self.isLoadingTimeLine = true;
        self.event = this.params.get("event");;
        
        self.userData.hasLoggedIn().subscribe((isLoggedIn) => {
            console.log(isLoggedIn);
            
            if(isLoggedIn){
                self.feedData.getAllOfflinePosts().subscribe((offlinePosts) => {
                    if(offlinePosts != null) {
                        console.log("Showing offline data first");
                        self.postsData = offlinePosts;
                    }
                });
                self.userData.getUser().subscribe((user) => {
                    self.currentUser = user;
                    self.loadTimeLine();
                    
                });
            }else{
                self.isLoadingTimeLine = false;
            }
        });        
    }

    private closeModals(){
        var self = this;
        if(self.modal){
            console.log("Post Submitted. Try to close any modal");

            self.modal.dismiss().then(function(){
                console.log("Modal dismissed");
            });    
        }
    }

    public openPostModal(){
        this.modal = this.modalController.create(ModalPostSubmit, {user: this.currentUser, eventId: this.event.key});
        this.modal.present();
    }

    public openMediaModal(mediaFile){
        console.log("opening media modal");
        this.modal = this.modalController.create(ModalMediaSubmit, {mediaUri: mediaFile, user: this.currentUser, eventId: this.event.key});
        this.modal.present();
    }

    public openCommentModal(post){
        console.log("opening comment modal");
        this.modal = this.modalController.create(ModalCommentSubmit, {post: post, user: this.currentUser});
        this.modal.present();
    }

    public openShareModal(post){
        console.log("opening share modal");
        this.modal = this.modalController.create(ModalShareSubmit, {post: post, user: this.currentUser});
        this.modal.present();
    }

    private initializeItems() {
        this.items = [
            // 'Amsterdam',
            // 'Bogota',
            // 'Buenos Aires',
            // 'Cairo',
            // 'Dhaka',
            // 'Edinburgh',
            // 'Geneva',
            // 'Genoa',
            // 'Glasglow',
            // 'Hanoi',
            // 'Hong Kong',
            // 'Islamabad',
            // 'Istanbul',
            // 'Jakarta',
            // 'Kiel',
            // 'Kyoto',
            // 'Le Havre',
            // 'Lebanon',
            // 'Lhasa',
            // 'Lima',
            // 'London',
            // 'Los Angeles',
            // 'Madrid',
            // 'Manila',
            // 'New York',
            // 'Olympia',
            // 'Oslo',
            // 'Panama City',
            // 'Peking',
            // 'Philadelphia',
            // 'San Francisco',
            // 'Seoul',
            // 'Taipeh',
            // 'Tel Aviv',
            // 'Tokio',
            // 'Uelzen',
            // 'Washington'
        ];
    }

    private loadTimeLine(){
        console.log("reloading timeline");
        var self = this;
        
        this.feedData.getAllPosts(self.event.key, this.settings.postsPerPage).subscribe(posts => {
            if(posts != null) {
                self.postsData = posts;                
                self.loadPostData();
                console.log("Post Loaded");
                self.newPost = self.postsData[0];
                self.hasNewPost = false;
                self.events.publish(EventCodes.POST_LOADED);
            } else {
                self.isLoadingTimeLine = false;
            }            
        }); 
    }

    private loadPostData(){
        let self=this;
        self.postsData.forEach(post =>{
            if(post.value.hasMedia){
                self.tasksToLoad ++;
                self.feedData.getPostMedia(post.key).subscribe(media => {
                    media.viewCount ++;
                    post.media = media;

                    //Update counts back to Firebase
                    self.feedData.updatePostMedia(post.key, media).subscribe(result=>{
                        //console.log("Updated count for media", result);
                    });

                    self.tasksToLoad --;
                    self.storePostData();
                });
            }

            if(post.value.likeCount > 0){
                self.tasksToLoad ++;
                self.feedData.getPostLikes(post.key).subscribe(likeUsers => {
                    post.likes = likeUsers;
                    self.tasksToLoad --;
                    self.storePostData();
                });
            }

            if(post.value.commentCount > 0){
                self.tasksToLoad ++;
                self.feedData.getPostComments(post.key, this.settings.commentsPerPage).subscribe(comments => {
                    post.comments = comments;
                    self.tasksToLoad --;
                    self.storePostData();
                });
            }
        });
        
        self.isLoadingTimeLine = false;
    }

    private storePostData(){
        // console.log(this.tasksToLoad);
        if(this.tasksToLoad == 0){
            console.log("Done loading. Storing for global timeline");
            this.feedData.setAllOfflinePosts(this.postsData);
        }
    } 

    public getItems(ev) {
        // Reset items back to all of the items
        this.initializeItems();

        // set val to the value of the ev target
        var val = ev.target.value;

        // if the value is an empty string don't filter the items
        if (val && val.trim() != '') {
            this.items = this.items.filter((item) => {
                return (item.toLowerCase().indexOf(val.toLowerCase()) > -1);
            })
        }
    }

    public onSearchBarFocus (ev){
        this.isShowingSuggestedKeywords = true;
    }

    public onSearchBarBlur(ev){
        this.isShowingSuggestedKeywords = false;
    }

    public getNameInitials(name){
        return Utils.getFirstInitials(name);
    }

    public formatNum(num){
        if(!num){return "";}
        return Utils.formatNumberToString(num);
    }

    // Post Media section

    public addMedia(){
        let actionSheet = this.actionsheetController.create({
            title: '',
            buttons: [
              {
                text: 'Take a new picture',
                handler: () => {
                  this.openCamera('photo');
                }
              },
              // {
              //   text: 'Record a video',
              //   handler: () => {
              //     this.openCamera('video');
              //   }
              // },
              {
                text: 'Import from phone',
                handler: () => {
                  this.openCamera('library');
                }
              },
              {
                text: 'Cancel',
                role: 'cancel',
                handler: () => {
                  console.log('Cancel clicked');
                }
              }
            ]
        });
        actionSheet.present();
    }

    private setCameraOptions(srcType){
        var options = {
            // Some common settings are 20, 50, and 100
            quality: 80,
            destinationType: Camera.DestinationType.FILE_URI,
            // In this app, dynamically set the picture source, Camera or photo gallery
            sourceType: srcType,
            encodingType: Camera.EncodingType.JPEG,
            mediaType: Camera.MediaType.PICTURE,
            // allowEdit: true,
            correctOrientation: true  //Corrects Android orientation quirks
        }
        return options;
    }
    
    private openCamera(selection) {
        let self = this;
        let srcType = {};

        self.showLoading();

        if (selection=="photo"){
            srcType = Camera.PictureSourceType.CAMERA;
        }else{
            srcType = Camera.PictureSourceType.PHOTOLIBRARY;
        }

        var options = this.setCameraOptions(srcType);

        navigator.camera.getPicture(function cameraSuccess(mediaUri) {
            console.log("Got fileUri from phone");
            self.hideLoading();
            self.loading.onDidDismiss(() => {
                self.openMediaModal(mediaUri);
            }); 
        }, function cameraError(error) {
            self.hideLoading();
            self.loading.onDidDismiss(() => {
                console.debug("Unable to obtain picture: " + error, "app");
            });
        }, options);
    }

    private updateLike(post, isLike){
        //Update LikeCount back to Firebase
        if (!post){return;}
        let self = this;

        if(isLike){
            post.value.likeCount ++;
        }else{
            if(post.value.likeCount > 0){post.value.likeCount --;}
        }
        this.feedData.updatePostLike(post.key, self.currentUser.uid, post.value, isLike, this.myLike(post)).subscribe(result=>{
            if(isLike){
                if(result!=false){
                    if(post.likes == null){post.likes = [];}
                    post.likes.push({
                        key:result, 
                        value: {uid:self.currentUser.uid}
                    })
                }
            }else{
                post.likes = _.reject(post.likes, function(userLike){
                    let uLike:any = userLike;
                    return uLike.value.uid == self.currentUser.uid;
                });
            }
            console.log("Updated Like Count for post", result);
        });
    }

    public myLike(post){
        let self = this;
        return _.find(post.likes, function(likeUser){
            let lUser:any = likeUser;
            return lUser.value.uid == self.currentUser.uid;
        });
    }

    public showLoading(){
        this.loading = this.helpers.showLoading();
    }

    public hideLoading(){
        this.helpers.hideLoading();
    }

    public getTimeSince(unixTime){
        return Utils.timeSince(unixTime);
    }

    public goToPage(page){
        switch (page) {
            case "account":
                this.nav.push(AccountPage);
                break;
            
            default:
                // code...
                break;
        }
    }

    public loadUserFeed(timelineUser){
        this.nav.push(UserFeedPage, {timelineUser: timelineUser});
    }

    public loadNewsDetail(newsItem){
        this.nav.push(NewsDetailsPage, {item: newsItem});
    }

    public loadEventDetail(event){
        if(event.value.link.type=='inapp'){
            // this.nav.push(DynamicPage, {name: event.value.link.url});
        }else{
            window.open(event.value.link.url, '_blank', 'location=no,closebuttoncaption=Close,toolbarposition=top');
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/feed/feed.ts